import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import ChevronIcon from '@assets/img/icons/chevron-2.svg?react';

import {
  H3,
  StringMain,
  StringSmall,
} from '@/components/Typography/Typography';
import { Button } from '@/components/ui/Button/Button';
import { Picture } from '@/components/ui/Picture/Picture';

import css from './styles.module.scss';

import usdPng from '/img/icons/usd-v2-large.png';
import usdWebp from '/img/icons/usd-v2-large.webp';
import faqBgPng from '/img/lottery/faq-banner-bg.png';
import faqBgWebp from '/img/lottery/faq-banner-bg.webp';

const LotteryFaqBanner: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className={css.lotteryFaqBanner}>
      <H3 weight="bold">{t('Ticket Draw')}</H3>
      <Button
        variant="transparent"
        className="flex items-center gap-[12px] !w-auto p-2"
        onClick={() => navigate(-1)}
      >
        <ChevronIcon className="text-white size-[16px]" />
        <StringMain>{t('Back')}</StringMain>
      </Button>
      <div className={css.rewardsInfo}>
        <Picture
          className="size-[24px] mr-2"
          img={usdPng}
          webp={usdWebp}
          alt="usd"
        />
        <StringSmall weight="medium">{t('USD Rewards')}</StringSmall>
      </div>
      <Picture
        img={faqBgPng}
        webp={faqBgWebp}
        alt="faq banner"
        className="absolute right-0 top-0 h-full w-auto -z-[1]"
      />
    </div>
  );
};

export { LotteryFaqBanner };
